import { render, staticRenderFns } from "./CheckboxConfig.vue?vue&type=template&id=3fc19734"
import script from "./CheckboxConfig.vue?vue&type=script&lang=js"
export * from "./CheckboxConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports